import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from "react-hot-toast";
import Box from '../../components/Box';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import RefreshButton from '../../components/RefreshButton';
import ColumnChooser from '../../components/ColumnChooser';
import TableConstantActions from '../../components/TableConstantActions';
import CustomTextInput from '../../components/CustomTextInput';
import CustomSwitch from '../../components/CustomSwitch';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import { kolonlariBirlestir } from '../../components/ColumnFilter/kolonBirlestir';
import ColumnFilterRow from '../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, foldText } from '../../components/ColumnFilter/ColumnFilterTypes';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { IzinService, IzinTuruItem } from '../../services/IzinService';

const EVET_HAYIR = [{ value: '1', label: 'Evet' }, { value: '0', label: 'Hayır' }];
const evetHayir = (b: boolean) => b ? 'Evet' : 'Hayır';

/** Ekranda süzme / sıralama için satırın kolon değeri. */
const kolonDegeri = (x: IzinTuruItem, kolon: string): string => {
    switch (kolon) {
        case 'kod': return x.kod;
        case 'ad': return x.ad;
        case 'ucretli': return x.ucretli ? '1' : '0';
        case 'yillikIzindenDuser': return x.yillikIzindenDuser ? '1' : '0';
        case 'yasalGun': return x.yasalGun == null ? '' : String(x.yasalGun).padStart(4, '0');
        case 'aktif': return x.aktif ? '1' : '0';
        case 'kullanimSayisi': return String(x.kullanimSayisi).padStart(6, '0');
        default: return '';
    }
}

interface EkranFiltresi {
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
}

/**
 * İzin Türleri (İnsan Kaynakları > Tanımlamalar, 03.11.2026). Kod puantaj hücresinde yazar (Yİ, Mİ, Eİ, Öİ, R ...).
 * İlk açılışta İş Kanunu'na göre varsayılan liste yüklenir. Kısa liste: tek ekran, üstte açılan form (Özel Günler kalıbı).
 */
const IzinTuruList = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Tanımlamalar > İzin Türleri"
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const formRef = useRef<any>(null);

    const [liste, setListe] = useState<IzinTuruItem[]>([]);
    const [filter, setFilter] = useState<EkranFiltresi>({ sortColumn: undefined, sortDirection: 'asc', columnFilters: [] });

    const [isOpen, setIsOpen] = useState(false);
    const [duzenlenenId, setDuzenlenenId] = useState<string | undefined>(undefined);
    const [kod, setKod] = useState<string | undefined>(undefined);
    const [ad, setAd] = useState<string | undefined>(undefined);
    const [yasalGun, setYasalGun] = useState<string | undefined>(undefined);
    const [ucretli, setUcretli] = useState<boolean>(true);
    const [yillikIzindenDuser, setYillikIzindenDuser] = useState<boolean>(false);
    const [aktif, setAktif] = useState<boolean>(true);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Kod', name: 'kod', order: 0, isVisible: true },
            { title: 'Ad', name: 'ad', order: 0, isVisible: true },
            { title: 'Ücretli', name: 'ucretli', order: 0, isVisible: true },
            { title: 'Yıllık İzinden Düşer', name: 'yillikIzindenDuser', order: 0, isVisible: true },
            { title: 'Gün', name: 'yasalGun', order: 0, isVisible: true },
            { title: 'Aktif', name: 'aktif', order: 0, isVisible: true },
            { title: 'Kayıt Sayısı', name: 'kullanimSayisi', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
        getData();
    }, [])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await IzinService.turListesi();

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            setListe((response.data ?? []).map(x => ({ ...x, isSelected: false })));
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const gorunen = liste.filter(x => (filter.columnFilters ?? []).every(f => {
        if (f.values && f.values.length > 0)
            return f.values.includes(kolonDegeri(x, f.column));

        if (f.text && f.text.trim())
            return foldText(kolonDegeri(x, f.column)).includes(foldText(f.text.trim()));

        return true;
    })).sort((a, b) => {
        if (!filter.sortColumn)
            return a.sira - b.sira;

        var r = kolonDegeri(a, filter.sortColumn).localeCompare(kolonDegeri(b, filter.sortColumn), 'tr');
        return filter.sortDirection == 'desc' ? -r : r;
    });

    const sortableColumns = ['kod', 'ad', 'ucretli', 'yillikIzindenDuser', 'yasalGun', 'aktif', 'kullanimSayisi'];
    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, (f?: EkranFiltresi) => { if (f) setFilter(f); });

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        kod: { type: 'text' },
        ad: { type: 'text' },
        ucretli: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
        yillikIzindenDuser: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
        aktif: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => setFilter({ ...filter, columnFilters });

    const setItemSelected = (_id: string) => setListe(liste.map(x => x.izinTuruId == _id ? { ...x, isSelected: !x.isSelected } : x));

    const selectAll = () => {
        var ids = gorunen.map(x => x.izinTuruId);
        var isAllSelected = gorunen.length > 0 && gorunen.every(x => x.isSelected);
        setListe(liste.map(x => ids.includes(x.izinTuruId) ? { ...x, isSelected: !isAllSelected } : x));
    }

    const secililer = liste.filter(x => x.isSelected);

    const scrollTo = () => setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);

    const formuDoldur = (o: IzinTuruItem | undefined) => {
        setDuzenlenenId(o?.izinTuruId);
        setKod(o?.kod);
        setAd(o?.ad);
        setYasalGun(o?.yasalGun == null ? undefined : String(o.yasalGun));
        setUcretli(o?.ucretli ?? true);
        setYillikIzindenDuser(o?.yillikIzindenDuser ?? false);
        setAktif(o?.aktif ?? true);
    }

    const yeniEkle = () => { formuDoldur(undefined); setIsOpen(true); scrollTo(); }
    const iptalEt = () => { formuDoldur(undefined); setIsOpen(false); }

    const ac = (o: IzinTuruItem | undefined) => {
        if (!o || !menu?.canUpdate)
            return;
        formuDoldur(o);
        setIsOpen(true);
        scrollTo();
    }

    const kaydet = async () => {
        try {
            if (!kod || kod.trim() == '') {
                toast.error("Kod alanı zorunludur.");
                return;
            }

            if (!ad || ad.trim() == '') {
                toast.error("Ad alanı zorunludur.");
                return;
            }

            var gun = yasalGun && yasalGun.trim() != '' ? Number(yasalGun) : null;

            if (gun != null && (isNaN(gun) || gun < 0)) {
                toast.error("Gün sayısı geçerli değil.");
                return;
            }

            dispatch(storeActivityIndicator(true));

            var response = await IzinService.turKaydet({
                izinTuruId: duzenlenenId ?? null,
                kod: kod.trim(),
                ad: ad.trim(),
                ucretli,
                yillikIzindenDuser,
                yasalGun: gun,
                aktif
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("İzin türü kaydedildi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const sil = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await IzinService.turSil(secililer.map(x => x.izinTuruId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("Seçilen izin türleri silindi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const hucre = (item: IzinTuruItem, column: string) => {
        var icerik: React.ReactNode;

        if (column == 'kod')
            icerik = <span className='badge ebbe-status-badge badge-light-success'>{item.kod}</span>;
        else if (column == 'ad')
            icerik = item.ad;
        else if (column == 'ucretli')
            icerik = evetHayir(item.ucretli);
        else if (column == 'yillikIzindenDuser')
            icerik = evetHayir(item.yillikIzindenDuser);
        else if (column == 'yasalGun')
            icerik = item.yasalGun ?? '';
        else if (column == 'aktif')
            icerik = <span className={'badge ebbe-status-badge ' + (item.aktif ? 'badge-light-primary' : 'badge-light')}>{item.aktif ? 'Aktif' : 'Pasif'}</span>;
        else if (column == 'kullanimSayisi')
            icerik = item.kullanimSayisi;

        return <td key={column} onClick={() => setItemSelected(item.izinTuruId)} onDoubleClick={() => ac(item)}>{icerik}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort((a, b) => a.order - b.order);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <TableConstantActions
                    deleteFunction={sil}
                    onSearchSubmit={(e) => e.preventDefault()}
                    pageName={pageName}
                    hideSearch={true}
                    searchTerm=''
                    selectedCount={secililer.length}
                    setSearchTerm={() => { }}
                    updateFunction={() => ac(secililer[0])}
                />

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

                {
                    menu?.canInsert && (
                        <div className='m-0'>
                            <a onClick={yeniEkle} className='btn btn-sm fw-bold btn-primary'>Yeni İzin Türü Ekle</a>
                        </div>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                {
                    isOpen && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-10 text-black">{duzenlenenId ? 'İzin Türünü Güncelle' : 'Yeni İzin Türü'}</h4>

                                    <div className="row">
                                        <div className="col-md-2">
                                            <CustomTextInput labelText="Kod" isLabelRequired value={kod} setValue={setKod} />
                                        </div>
                                        <div className="col-md-4">
                                            <CustomTextInput labelText="Ad" isLabelRequired value={ad} setValue={setAd} />
                                        </div>
                                        <div className="col-md-2">
                                            <CustomTextInput labelText="Gün" value={yasalGun} setValue={setYasalGun} />
                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-md-2">
                                            <label className="form-label">Ücretli</label>
                                            <CustomSwitch isActive={ucretli} setIsActive={setUcretli} />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Yıllık izinden düşer</label>
                                            <CustomSwitch isActive={yillikIzindenDuser} setIsActive={setYillikIzindenDuser} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Aktif</label>
                                            <CustomSwitch isActive={aktif} setIsActive={setAktif} />
                                        </div>
                                    </div>

                                    <div className="text-muted fs-7 mt-5">
                                        Kod puantaj hücresinde yazar. Gün, yasal ya da işyeri gün sayısıdır (bilgi). Kayıtta kullanılan tür silinemez; pasif yapılabilir.
                                    </div>

                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-5">
                                        <Box mr="15px">
                                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={iptalEt}>İptal Et</button>
                                        </Box>
                                        <Box>
                                            <button className="btn btn-primary btn-sm" onClick={kaydet}>Kaydet</button>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips columns={columns} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={gorunen.length > 0 && gorunen.every(x => x.isSelected)} />
                                                </label>
                                            </div>
                                        </th>
                                        {gorunenKolonlar.map(item => <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>)}
                                    </tr>
                                    <ColumnFilterRow columns={gorunenKolonlar} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} leadingCellCount={1} />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        gorunen.length == 0 && (
                                            <tr><td className="text-center" colSpan={99}>Kayıt bulunamadı.</td></tr>
                                        )
                                    }
                                    {
                                        gorunen.map(item =>
                                            <tr key={item.izinTuruId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.izinTuruId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>
                                                {gorunenKolonlar.map(c => hucre(item, c.name))}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="text-muted fs-7 py-3">
                            {gorunen.length} kayıt · Yasal süreler 4857 sayılı İş Kanunu'na göre: evlilik, ölüm ve evlat edinme 3 gün, babalık 5 gün, doğum 16 hafta. Sözleşme daha fazlasını verebilir.
                        </div>
                    </KTCardBody>
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default IzinTuruList;
